import { createModal } from '/@/core/elements/modal'

const { api, component } = createModal<{
  projectId: string
}>('ExportVideoModal', () => import('./ExportVideoModal.vue'), {
  projectId: '',
})

export const useCreateVideoModal = api
export default component
